import React, { Fragment, useState, useEffect } from "react";
import SummaryReport from "../reportComponents/SummaryReport";
import axios from "axios";
import { variables } from "../../Variables";
import MyDialog from "../UI/Dialog";
import theme from "../UI/Theme";
import { SyncLoader } from "react-spinners";

// MUI Imports
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import useMediaQuery from "@material-ui/core/useMediaQuery";

const SalesSummary = (props) => {
  const { tabInitialDate, tabFinalDate } = props;

  const [isLoading1, setIsLoading1] = useState(false);
  const [isLoading2, setIsLoading2] = useState(false);
  const [showDetails, setShowDetails] = useState(false);

  // For Sales information
  const [salesByDateList, setSalesByDateList] = useState([]);
  const [salesCancelledByDateList, setSalesCancelledByDateList] = useState([]);
  const [totalSalesByDate, setTotalSalesByDate] = useState(null);
  const [totalPagesByDate, setTotalPagesByDate] = useState(null);
  const [totalSalesCancelledByDate, setTotalSalesCancelledByDate] = useState(null);
  const [totalPagesCancelledByDate, setTotalPagesCancelledByDate] = useState(null);
  const [totalPagesByConsultant, setTotalPagesByConsultant] = useState(null);
  const [totalPagesCancelledByConsultant, setTotalPagesCancelledByConsultant] = useState(null);

  const matches2 = useMediaQuery(theme.breakpoints.down("md"));

  const showDetailsHandler = () => {
    setShowDetails((prev) => !prev);
  };

  const summaryInfo = {
    title: "Net Sales",
    titleSales: "Sales",
    titleCancelations: "cancelations",
    subtitle: "T. Pages",
    subtitle2: "Price/Page",
  };

  // --- API CALLS ---
  // const getSalesByDate = (start, end) => {
  //   setIsLoading1(true);
  //   axios
  //     .get(`${variables.API_URL}/sales/salesbydate/${start}/${end}`, { withCredentials: true })
  //     .then((res) => {
  //       const data = res.data.salesByDate || [];
  //       setSalesByDateList(data);

  //       if (data.length === 0) {
  //         setTotalSalesByDate(0);
  //         setTotalPagesByDate(0);
  //       } else {
  //         const totalSales = data.slice(-1)[0];
  //         setTotalSalesByDate(totalSales.cumulative_sum);
  //         setTotalPagesByDate(totalSales.cumulative_sum_pages);
  //       }
  //       setIsLoading1(false);
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching sales:", error);
  //       setIsLoading1(false);
  //     });
  // };


  // --- API CALLS (UPDATED ROUTES & FRONTEND MATH) --- Updated on 16.Jul.26
  const getSalesByDate = (start, end) => {
    setIsLoading1(true);
    axios
      // Pointing to your brand-new summary endpoint:
      .get(`${variables.API_URL}/sales/salesbysummary/${start}/${end}`, { withCredentials: true })
      .then((res) => {
        const data = res.data.salesByDate || [];
        setSalesByDateList(data);

        if (data.length === 0) {
          setTotalSalesByDate(0);
          setTotalPagesByDate(0);
        } else {
          // Calculate sum safely on the frontend
          const salesSum = data.reduce((acc, curr) => acc + Number(curr.NET_AMOUNT || 0), 0);
          const pagesSum = data.reduce((acc, curr) => acc + Number(curr.PRODUCT_VALUE || 0), 0);
          
          setTotalSalesByDate(Number(salesSum.toFixed(2))); 
          setTotalPagesByDate(pagesSum);
        }
        setIsLoading1(false);
      })
      .catch((error) => {
        console.error("Error fetching sales summary:", error);
        setIsLoading1(false);
      });
  };
  // --- API CALLS (UPDATED ROUTES & FRONTEND MATH) --- Updated on 16.Jul.26 - END


  // const getSalesCancelledByDate = (start, end) => {
  //   setIsLoading2(true);
  //   axios
  //     .get(`${variables.API_URL}/sales/salescancelledbydate/${start}/${end}`, { withCredentials: true })
  //     .then((res) => {
  //       const data = res.data.salesCancelledByDate || [];
  //       setSalesCancelledByDateList(data);

  //       if (data.length === 0) {
  //         setTotalSalesCancelledByDate(0);
  //         setTotalPagesCancelledByDate(0);
  //       } else {
  //         const amounts = data.map(item => item.cumulative_sum);
  //         const pages = data.map(item => item.cumulative_sum_pages);
  //         setTotalSalesCancelledByDate(Math.max(...amounts));
  //         setTotalPagesCancelledByDate(Math.max(...pages));
  //       }
  //       setIsLoading2(false);
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching cancellations:", error);
  //       setIsLoading2(false);
  //     });
  // };

  // --- API CALLS (UPDATED ROUTES & FRONTEND MATH) --- Updated on 16.Jul.26 - Cancelations

  const getSalesCancelledByDate = (start, end) => {
    setIsLoading2(true);
    axios
      // Pointing to your brand-new cancellations summary endpoint:
      .get(`${variables.API_URL}/sales/cancellationsbysummary/${start}/${end}`, { withCredentials: true })
      .then((res) => {
        const data = res.data.salesCancelledByDate || [];
        setSalesCancelledByDateList(data);

        if (data.length === 0) {
          setTotalSalesCancelledByDate(0);
          setTotalPagesCancelledByDate(0);
        } else {
          // Calculate sum safely on the frontend
          const cancelledSum = data.reduce((acc, curr) => acc + Number(curr.NET_AMOUNT || 0), 0);
          const cancelledPages = data.reduce((acc, curr) => acc + Number(curr.PRODUCT_VALUE || 0), 0);

          setTotalSalesCancelledByDate(Number(cancelledSum.toFixed(2)));
          setTotalPagesCancelledByDate(cancelledPages);
        }
        setIsLoading2(false);
      })
      .catch((error) => {
        console.error("Error fetching cancellations summary:", error);
        setIsLoading2(false);
      });
  };
  // --- API CALLS (UPDATED ROUTES & FRONTEND MATH) --- Updated on 16.Jul.26 - Cancelations -- END

  const totalPagesByConsultantHandler = (pages) => setTotalPagesByConsultant(pages);
  const totalPagesCancelledByConsultantHandler = (pages) => setTotalPagesCancelledByConsultant(pages);

  // --- EFFECT: Re-fetch only when dates change ---
  useEffect(() => {
    if (tabInitialDate && tabFinalDate) {
      getSalesByDate(tabInitialDate, tabFinalDate);
      getSalesCancelledByDate(tabInitialDate, tabFinalDate);
    }
  }, [tabInitialDate, tabFinalDate]); // CRITICAL: Added dependencies here

  return (
    <Fragment>
      {!isLoading1 && !isLoading2 ? (
        <Fragment>
          <SummaryReport
            summaryInfo={summaryInfo}
            totalSalesByConsultant={totalSalesByDate}
            totalSalesCancelledByConsultant={totalSalesCancelledByDate}
            totalPagesByConsultant={totalPagesByDate}
            totalPagesCancelledByConsultant={totalPagesCancelledByDate}
            salesByDateList={salesByDateList}
            salesCancelledByDateList={salesCancelledByDateList}
            tabInitialDate={tabInitialDate}
            tabFinalDate={tabFinalDate}
            link={true}
            boxSize={matches2 ? "auto" : 325}
            boxMargin={2}
          />

          <Button
            onClick={showDetailsHandler}
            sx={{ color: "#7A1125", textTransform: "capitalize", fontSize: "0.7rem" }}
          >
            <FormatListBulletedIcon sx={{ fontSize: 20, color: "#4E1721", marginRight: 2 }} />
            {showDetails ? "Hide" : "more..."}
          </Button>

          <MyDialog
            salesByDateList={salesByDateList}
            salesCancelledByDateList={salesCancelledByDateList}
            showDetails={showDetails}
            showDetailsHandler={showDetailsHandler}
            title="Sales"
            tabInitialDate={tabInitialDate}
            tabFinalDate={tabFinalDate}
            totalPagesByConsultantHandler={totalPagesByConsultantHandler}
            totalPagesCancelledByConsultantHandler={totalPagesCancelledByConsultantHandler}
          />
        </Fragment>
      ) : (
        <Box textAlign="center" sx={{ py: 2 }}>
          <SyncLoader color="#7A1125" size={15} />
        </Box>
      )}
    </Fragment>
  );
};

// React.memo con comparación de fechas para evitar re-renders innecesarios desde el Dashboard
export default React.memo(SalesSummary, (prevProps, nextProps) => {
  return (
    prevProps.tabInitialDate === nextProps.tabInitialDate &&
    prevProps.tabFinalDate === nextProps.tabFinalDate
  );
});